"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TagCloud", {
  enumerable: true,
  get: function get() {
    return _TagCloud.TagCloud;
  }
});

var _TagCloud = require("./TagCloud");